// @HACK: Messages in Canada are not being delivered because we're currently using a long code to send Canadian messages,
// and they're not being delivered because they contain a url.
// Remove this once a Canadian short code is introduced
const noSmsLinkShopIds = ['1a9c8b4a-e4b2-478b-b3c6-491d0d3fa9e7', 'd80466c0-5b68-4540-b8d9-5a48f7432c8b'];
export const isLinkInSmsSupported = shop => !noSmsLinkShopIds.includes(shop.id);
